import {VerifyService} from "../../service/VerifyService";
import {useCallback, useState} from "react";
import {useNavigate} from "react-router-dom";

interface SelectDocumentTemplateViewModelReturn {
    loading: boolean,
    selectDocumentTemplate: (verificationId: string, chosenDocumentId: string) => void
}

export const SelectDocumentTemplateViewModel = (): SelectDocumentTemplateViewModelReturn => {

    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const selectDocumentTemplate = useCallback(async (verificationId: string, chosenDocumentId: string) => {
        setLoading(true)
        const service = VerifyService.getInstance()
        await service.selectDocumentTemplate(verificationId, chosenDocumentId)
        setLoading(false)
        navigate(`../${verificationId}/consent`)
    }, [navigate])

    return {
        loading,
        selectDocumentTemplate
    }

}